function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 10v140h110V92.115l-49.906 49.906-51.62-51.619 30.407-30.406L80.094 81.21 130 31.303V10H20z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 10c-5.5 0-10 4.5-10 10v130c0 5.5 4.5 10 10 10h110c5.5 0 10-4.5 10-10V82.115l-20 20V140H30V10zm100 0v31.303l20-20V20c0-5.5-4.5-10-10-10z",
  fill: "#9a6724"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M105 20L85 0H65L45 20v20h60z",
  fill: "#7b8da1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M80.094 130L40.496 90.402 58.88 72.018 80.094 93.23l61.518-61.519 18.385 18.385z",
  fill: "#3a9a66"
});

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.c20360382b4c1d792fa41e56fe54d496.svg";
export { ForwardRef as ReactComponent };